import React from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as Star } from 'mui/assets/icons/star.svg';
import { StyledRating, StyledReviewLink } from './styles';

const DS_StarRating = ({ rating, reviewsAmount, reviewsUrl }) => {
  return (
    <StyledRating>
      {!!rating && (
        <Typography variant="DS_copyMediumRegular" component="p">
          {rating}
        </Typography>
      )}
      <SvgIcon component={Star} inheritViewBox={true} sx={{ fontSize: 24 }}></SvgIcon>
      {!!reviewsAmount && reviewsUrl && <StyledReviewLink url={reviewsUrl}>{reviewsAmount} Reviews</StyledReviewLink>}
    </StyledRating>
  );
};

export default DS_StarRating;
